<div class="container-fluid p-3">
  <div class="d-flex gap-2">
    <mat-form-field appearance="outline" >
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      <!--            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
      <!--            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->

    </mat-form-field>&nbsp;
    <mat-form-field appearance="outline" >
      <mat-label >Centre Name</mat-label>
      <mat-select  aria-label="Default select example" [formControl]="SelectCentre" (selectionChange)="fetchByCenter($event)">
        <mat-option  [value]="{centreCode:'All',centreName:'All Centres'}">All</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c">{{c.centreName}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field  appearance="outline" >
      <mat-label  >Volunteer</mat-label>
      <mat-select [(value)]="mVolunteer" >
        <mat-option  value="All">All</mat-option>

        <mat-option *ngFor="let t of volunteers$|async"  [value]="t">{{t}}</mat-option>

      </mat-select>
    </mat-form-field>
  </div>
<div class="d-flex gap-1">

  <mat-form-field  appearance="outline" >
    <mat-label  >Session Type</mat-label>
    <mat-select [(value)]="mSession" (selectionChange)="filterData()">
      <mat-option  value="All">All</mat-option>

      <mat-option *ngFor="let t of sessionTypes"  [value]="t">{{t}}</mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field  appearance="outline" >
    <mat-label  >Teacher</mat-label>
    <mat-select [(value)]="mTeacher" (selectionChange)="filterData()">
      <mat-option  value="All">All</mat-option>

      <mat-option *ngFor="let t of teachers$|async"  [value]="t.userName">{{t.userName}}</mat-option>

    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Conducted By</mat-label>
    <mat-select [(value)]="mConductedBy" (selectionChange)="filterData()">
      <mat-option value="All">All</mat-option>
      <mat-option value="teacher">By Teacher</mat-option>
      <mat-option value="volunteer">By Volunteer</mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
  <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>
</div>

  <div class="row mt-3" *ngIf="dataSource.data.length > 0">
    <div class="col-md-12">
      <mat-card class="summary-card">
        <mat-card-header>
          <mat-card-title>Report Summary</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-md-3">
              <div class="stat-box">
                <div class="stat-value">{{ teacherCount }}</div>
                <div class="stat-label">Total Session Count</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="stat-box stat-new">
                <div class="stat-value">{{ totalSessionChildCount }}</div>
                <div class="stat-label">Total Session Child Count</div>
              </div>
            </div>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <section class="card">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Education Group Sessions</h2>
        </li>

        <li class="dropdown m-l-20">
          <label for="search-input">
            <i class="material-icons search-icon">search</i>
          </label>
          <input
            placeholder="Search"
            id="search-input"
            type="text"
            class="browser-default search-field"
            (keyup)="applyFilter($event)">
        </li>
<!--        <li class="dropdown ms-3">-->
<!--          <h4 class="mb-0">Total Session Count :<strong>{{ dataSource.data.length }}</strong> &nbsp;&nbsp;Total Session Child Count :<strong>{{ totalSessionChildCount }}</strong> </h4>-->
<!--        </li>-->
      </ul>

      <ul class="header-buttons mr-2">
        <li class="me-2">
          <button  permission="Group Session" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" mat-mini-fab color="primary" (click)="AddGroupSession()">
            <mat-icon class="col-white" >add</mat-icon>
          </button>
        </li>


        <li>
          <button
            mat-mini-fab color="accent"
            (click)="downloadExcel()" permission="Group Session" [permissionTypes]="[PermissionType.EXCEL, PermissionType.ALL]">
            <mat-icon>download</mat-icon>
          </button>
        </li>
        <!--      <li>-->
        <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
        <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
        <!--        </div>-->
        <!--      </li>-->
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <table mat-table [dataSource]="dataSource" class="  example-container">

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="sr.no">
        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
        <td mat-cell *matCellDef="let element; let i=index"> {{i+1}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="childrenNames">
        <th mat-header-cell *matHeaderCellDef>Name </th>
        <td mat-cell *matCellDef="let element" >{{element.childrenNames}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element?.remark"> {{element.status||'Pending'}} </td>
      </ng-container>
      <!-- Weight Column -->
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef> Centre </th>
        <td mat-cell *matCellDef="let element">{{getCentresString(element.centres)}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="sessionDate">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element"> {{(element.sessionDate).toDate() | date : 'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="startTime">
        <th mat-header-cell *matHeaderCellDef>Timing</th>
        <td mat-cell *matCellDef="let element">{{getTime(element.startTime)}}  </td>
      </ng-container>
      <ng-container matColumnDef="sessionType">
        <th mat-header-cell *matHeaderCellDef>Type of Session</th>
        <td mat-cell *matCellDef="let element">{{element.sessionType}}  </td>
      </ng-container>
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Subject</th>
        <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
      </ng-container>
      <ng-container matColumnDef="topicsCovered">
        <th mat-header-cell *matHeaderCellDef>Topic Covered</th>
        <td mat-cell *matCellDef="let element"> {{element.topicsCovered}} </td>
      </ng-container>
      <ng-container matColumnDef="sessionChildCount">
        <th mat-header-cell *matHeaderCellDef>Session Child Count</th>
        <td mat-cell *matCellDef="let element">
          {{ element.countType === 'bychildren' ? element.children?.length || 0 : 0 }}
        </td>
      </ng-container>
<!--      <ng-container matColumnDef="remark">-->
<!--        <th mat-header-cell *matHeaderCellDef>Remark</th>-->
<!--        <td mat-cell *matCellDef="let element"> {{element.remark}} </td>-->
<!--      </ng-container>-->
      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef>Teacher</th>
        <td mat-cell *matCellDef="let element">{{element.submittedBy}}  </td>
      </ng-container>
      <ng-container matColumnDef="volunteerName">
        <th mat-header-cell *matHeaderCellDef>Volunteer</th>
        <td mat-cell *matCellDef="let element">{{element.volunteerName}}  </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Created At </th>
        <td mat-cell *matCellDef="let element"[matTooltip]="element.id" > <span *ngIf='element.createdAt' >{{getDateandTime(element?.createdAt)}}</span> </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
        <div class="d-flex">
          <button permission="Group Session" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>
<!--          <button permission="Group Session" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" mat-icon-button color="primary" (click)="viewEdit(element)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>-->
          <button  mat-icon-button color="warn" (click)="viewEdit(element)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
          <button permission="Group Session" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]" mat-icon-button color="warn" (click)="delete(element)" matTooltip="Delete"><mat-icon>delete</mat-icon></button>

        </div>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"
                   showFirstLastButtons
                   aria-label="Select page">
    </mat-paginator>
  </section>
  </div>

